import { AdvancingFilesPanel } from "advancing/files/AdvancingFilesPanel";
import { getProvideSidePanelQuery } from "advancingprovide/utils";
import React from "react";
import { useLoaderData, useParams } from "react-router";

export const FilesTab = () => {
  const { secret } = useParams();
  const { advancingSession } = useLoaderData<server.viewmodel.AdvancingProvideFrontModel>();

  return <AdvancingFilesPanel
    advancingSessionId={advancingSession.advancingSessionId}
    instruction={{ secret }}
    sidePanelQueryKey={getProvideSidePanelQuery(secret).queryKey}
  />;
};
